<template>
    <DCard
        padding
    >
        <DRow class="mb-3">
            <DCol sm="4">
                <DSelect
                    id="tenant-filter"
                    v-model="tenantFilter"
                    :label="__('settings.roles.index.table.filters.tenant')"
                    :options="tenantOptions"
                    @update:value="manageTenantUpdate"
                />
            </DCol>
            <DCol sm="4">
                <DSelect
                    id="permission-filter"
                    v-model="permissionFilter"
                    :label="__('settings.roles.index.table.filters.permission')"
                    :options="permissions"
                    @update:value="managePermissionUpdate"
                />
            </DCol>
            <DCol
                sm="3"
                class="p-1"
            >
                <DButton
                    id="filter-reset"
                    class="mt-3"
                    icon="filter-off"
                    :label="__('messages.actions.reset_filter')"
                    @click="resetFilters"
                />
            </DCol>
        </DRow>
        <DTable
            :fields="[
                {key: 'id', label: __('settings.roles.index.table.headers.id')},
                {key: 'name', label: __('settings.roles.index.table.headers.name')},
                {key: 'tenants', label: __('settings.roles.index.table.headers.tenants')},
                {key: 'actions', label: ''}
            ]"
            :items="roles"
        >
            <template #tenants="{item}">
                <td>
                    <DTag
                        v-for="tenant in item.tenants"
                        :key="tenant.id"
                        :label="tenant.id"
                        class="me-1"
                        :class="tenantFilter === tenant.id ? 'border border-danger' : ''"
                        :color="tenantFilter === tenant.id ? 'danger' : 'secondary'"
                    />
                </td>
            </template>
            <template #actions="{item}">
                <td style="width: 150px">
                    <div style="display: flex; grid-gap: 10px;">
                        <DButton
                            v-if="userPermissions.includes('role.edit')"
                            :id="`edit_${item.id}`"
                            icon="pencil"
                            mini
                            @click="$inertia.get($route('settings.roles.edit', {role: item.id}))"
                        />
                        <DButton
                            v-if="userPermissions.includes('role.delete')"
                            :id="`btn-delete-${item.id}`"
                            icon="trash-can-outline"
                            color="danger"
                            :disabled="item.users.length !== 0 || isInLoadingState"
                            mini
                            @click="deleteRole(item)"
                        />
                    </div>
                </td>
            </template>
        </DTable>

        <DFabs>
            <DFab
                v-if="userPermissions.includes('role.create')"
                id="btn-add"
                icon="plus"
                :label="__('settings.roles.index.add_role_button')"
                @click="showCreateRole()"
            />
        </DFabs>

        <DModal
            v-model:show="modalVisible"
            :title="__('settings.roles.index.delete_confirm_modal.title')"
            :message="__('settings.roles.index.delete_confirm_modal.message')"
            is-confirm
            is-error
            @close="modalVisible = false"
            @confirm="deleteAcceptCallback"
        />

        <CreateRoleModal
            v-if="createRoleModalVisible"
            v-model:show="createRoleModalVisible"
            :role-options-prop="mappedRoles()"
            @close="createRoleModalVisible = false"
            @confirmRole="createRoleCallback"
        />
    </DCard>
</template>

<script>
import CreateRoleModal from '~@/Components/Users/Roles/CreateRoleModal'

export default {
    name: 'RoleIndex',
    components: {
        CreateRoleModal
    },
    props: {
        roles: {
            type: Array,
            default: () => { return [] }
        },
        tenantOptions: {
            type: Array,
            default: () => { return [] }
        },
        appliedTenant: {
            type: String,
            default: null
        },
        appliedPermission: {
            type: String,
            default: null
        },
        permissions: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            modalVisible: false,
            createRoleModalVisible: false,
            tenantFilter: this.appliedTenant,
            permissionFilter: this.appliedPermission,
            deleteAcceptCallback: () => { return {} },
            createRoleCallback: () => { return {} }
        }
    },
    computed: {
        userPermissions () {
            return this.$page.props.auth.permissions
        }
    },
    methods: {
        deleteRole (item) {
            this.modalVisible = true
            this.deleteAcceptCallback = () => {
                this.modalVisible = false
                this.$inertia.delete(this.$route('settings.roles.destroy', { role: item.id }))
            }
        },
        showCreateRole () {
            this.createRoleModalVisible = true
            this.createRoleCallback = (role) => {
                this.modalVisible = false
                this.$inertia.get(this.$route('settings.roles.create', {
                    role: role
                }))
            }
        },
        applyFilter () {
            this.$inertia.get(this.$route('settings.roles.index', {
                tenantFilter: this.tenantFilter,
                permissionFilter: this.permissionFilter,
                save_filters: true
            }))
        },
        manageTenantUpdate (value) {
            this.tenantFilter = value
            this.applyFilter()
        },
        managePermissionUpdate (value) {
            this.permissionFilter = value
            this.applyFilter()
        },
        mappedRoles () {
            return this.roles.map(obj => ({
                label: obj.name,
                value: obj.name
            }))
        },
        resetFilters () {
            this.permissionFilter = null
            this.tenantFilter = null
            this.$inertia.get(this.$route('settings.roles.index', {
                save_filters: true,
                default_filters: true
            }))
        }
    }
}
</script>
